import React, { useState } from 'react';
import {
  TextField,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import { useAuth } from '../../context/AuthContext';
import AuthFlowLayout from './AuthFlowLayout';
import { authDarkFieldSx, authPrimaryButtonSx } from './authStyles';

const VerifyEmail = ({ email, onVerified }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { confirmSignUp } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await confirmSignUp(email, code.trim());
      onVerified();
    } catch (err) {
      setError(err.message || 'Failed to verify email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthFlowLayout
      icon={MarkEmailReadIcon}
      title="Verify your email"
      subtitle={`Enter the code we sent to ${email}`}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2, borderRadius: 1.5 }}>
          {error}
        </Alert>
      )}

      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Verification code"
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          margin="normal"
          required
          autoComplete="one-time-code"
          autoFocus
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
          placeholder="6-digit code"
          sx={authDarkFieldSx}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          disabled={loading}
          sx={authPrimaryButtonSx}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Verify email'}
        </Button>
      </form>
    </AuthFlowLayout>
  );
};

export default VerifyEmail;
